import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export default function Seo() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const title = t("seo.title");
  const description = t("seo.description");

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://wise-mate.ai/metaImg.jpg" />
      <meta property="og:image:alt" content="Wise Mate" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content="https://wise-mate.ai" />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:image" content="https://wise-mate.ai/metaImg.jpg" />
      <meta name="twitter:image:alt" content="Wise Mate" />
    </Helmet>
  );
}
